import type {
  CategoryDataSource,
  VendorCategoryParams,
} from '~/api/data-source/category';
import { categoryDataSource } from '~/api/data-source/category';
import type { DisplayCategoryTree } from '~/api/model';
import { displayCategoryTreeSchema, parseModel } from '~/api/model';

export interface CategoryRepository {
  getCategoryTree(): Promise<DisplayCategoryTree>;
  getCategoryDescendants(
    displayCategoryId: number,
  ): Promise<DisplayCategoryTree>;
  getVendorCategories(
    params: VendorCategoryParams,
  ): Promise<DisplayCategoryTree>;
}

export class CategoryRepositoryImpl implements CategoryRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: CategoryDataSource = categoryDataSource,
  ) {}

  async getCategoryTree() {
    const response = await this.dataSource.getCategoryTree();
    return parseModel(
      displayCategoryTreeSchema,
      response,
      'DisplayCategoryTree',
    );
  }

  async getCategoryDescendants(displayCategoryId: number) {
    const response = await this.dataSource.getCategoryDescendants(
      displayCategoryId,
    );
    return parseModel(
      displayCategoryTreeSchema,
      response,
      'DisplayCategoryTree',
    );
  }

  async getVendorCategories(params: VendorCategoryParams) {
    const response = await this.dataSource.getVendorCategories(params);
    return parseModel(
      displayCategoryTreeSchema,
      response,
      'DisplayCategoryTree',
    );
  }
}

export const categoryRepository = new CategoryRepositoryImpl();
